<template>
  <v-container>
    <v-row class="mb-5 justify-end">
      <v-flex lg2 md2 sm4 xs4 class="black">
        <v-btn class="black white--text" @click="signOut">
          signOut
          <v-icon right>exit_to_app</v-icon>
        </v-btn>
      </v-flex>
    </v-row>

    <!-- Header -->
    <v-row class="justify-center mb-3">
      <v-flex lg1 md1 sm2 xs2>
        <v-img height="75px" width="75px" src="@/assets/logo1.png"></v-img>
      </v-flex>
      <div class="text-center mt-5 changefont">Tai Kitchen Admin Panel</div>
    </v-row>

    <!-- dropdown for where to upload -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text">1. Select which part to Edit</div>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg6 md6 sm10 xs10>
        <v-select :items="items" @input="setSelected" label="Please select field" dense solo></v-select>
      </v-flex>
    </v-row>

    <!-- dropdown for dink only -->
    <v-row v-if="drink" class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text">1.1 Select the drink</div>
      </v-flex>
    </v-row>
    <v-row v-if="drink" class="justify-center">
      <v-flex lg6 md6 sm10 xs10>
        <v-select
          :items="drinks"
          @input="setSelectedDrink"
          label="Please select drink field"
          dense
          solo
        ></v-select>
      </v-flex>
    </v-row>

    <!-- show the photo that exit in selected dropdown -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text">2 .Delete Image (by click on the image that your want to delete)</div>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg6 md6 sm10 xs10>
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col
                v-for="document in Documents()"
                :key="document.data().imageUrl"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile @click="onImageTap(document.data().imageUrl, document.ref.id)">
                  <v-img
                    :src="document.data().imageUrl"
                    :lazy-src="document.data().imageUrl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
    </v-row>

    <v-dialog v-model="dialog" width="300">
      <v-card>
        <v-card-title>Delete</v-card-title>
        <v-card-text>Do you really want to delete.</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn small color="black" class="white--text" @click="onDelete()">Delete</v-btn>
          <v-btn small color="error" @click="onCancel()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- photo upload button and space to look perview  -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text">3. Select image to upload</div>
      </v-flex>
    </v-row>

    <v-row class="justify-start my-5">
      <v-flex lg3 md3 sm1 xs1></v-flex>

      <div v-if="imageError" class="imageError">{{imageError}}</div>
    </v-row>

    <v-row class="justify-center">
      <v-flex lg6 md6 sm10 xs10>
        <div>
          <v-btn @click="onPickFile">Select Image</v-btn>
          <input
            type="file"
            style="display: none"
            ref="recInput"
            accept="image/*"
            @change="onFilePicked"
          />
        </div>
      </v-flex>
    </v-row>

    <v-row class="justify-start">
      <v-flex lg3 md3 sm1 xs1></v-flex>
      <img :src="imageUrl" class="white--text" style="margin-top:30px;" height="50%" width="50%" />
    </v-row>

    <!-- upload button -->
    <v-row class="justify-center my-5">
      <v-flex lg6 md6 sm10 xs10>
        <div class="white--text">4. Upload the image</div>
      </v-flex>
    </v-row>

    <v-row class="justify-center mb-10">
      <v-flex lg6 md6 sm10 xs10>
        <v-btn @click="uploadImage">upload</v-btn>
      </v-flex>
    </v-row>

    <loader></loader>

    <v-row></v-row>
  </v-container>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import loader from "@/components/loader.vue";
const MAX_SIZE = 500000;

export default {
  components: {
    loader
  },

  data: () => ({
    items: [
      "Tai Kitchen Special Menu",
      "Chef's Special Menu",
      "Drink Special Menu",
      "Drink",
      "Appetizer",
      "Chicken",
      "Dessert",
      "Duck",
      "Fish",
      "Pork",
      "Salad",
      "Seafood",
      "Side Dish",
      "Soup",
      "Vegetable"
    ],

    drinks: [
      "Hot Beverages",
      "Cold Beverages",
      "Flavour Cappuccino",
      "Frappuccino",
      "Smoothie",
      "Soda Drink",
      "Coffee Liqueur",
      "Fresh Juice & Soft Drink",
      "Cocktail",
      "Aperitifs & Gin, Vodka",
      "Beer, Rum & Tequila, Liqueur",
      "Wine(Red Wine,White Wine)",
      "Whisky",
      "Whisky(Bourbon,Irish,Cognac)",
      "Whisky(Duty Free)",
      "Tai Kitchen's Corkage Charges,Bottle Charges"
    ],

    drink: "",
    selectedDrink: "",
    imageUrl: "",
    imageData: "",
    collection: "",
    uploadValue: "",
    dialog: false,
    imageToDelete: "",
    docRef: "",

    image: {
      size: "",
      height: "",
      width: ""
    },
    imageError: ""
  }),

  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "Login" });
        });
    },

    onPickFile() {
      this.$refs.recInput.click();
    },

    onFilePicked(event) {
      this.imageError = "";

      const files = event.target.files;
      let filename = files[0].name;

      this.image.size = files[0].size;
      if (this.image.size > MAX_SIZE) {
        this.imageError = `The image size (${this.image.size}) is too much (max is ${MAX_SIZE}).`;
        return;
      }

      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.imageData = files[0];
    },

    Documents() {
      return this.$store.getters.getImages;
    },

    setSelected(value) {
      if (value == "Drink") {
        this.drink = "drink";
        this.$store.commit("getImage", value);

      } else {
        this.$store.commit("getImage", value);
        this.drink = "";
      }
      this.collection = value;
    },

    setSelectedDrink(value) {
      this.selectedDrink = value;
      this.$store.commit("getImage", value);
    },

    uploadImage() {
      //check all field is not empty
      if (!this.imageData || !this.imageData) {
        alert("Please selet the image to upload");
        return;
      }

      if (!this.collection) {
        alert("Please selet which part to edit");
        return;
      }

      if (this.collection == "Drink") {
        if (!this.selectedDrink) {
          alert("Please selet the specific drink.");
          return;
        }
      }

      this.$store.commit("Loader", true);
      const storageRef = firebase
        .storage()
        .ref(`${this.imageData.name}`)
        .put(this.imageData);

      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          this.$store.commit("Loader", false);
          alert(error.message);
        },
        () => {
          storageRef.snapshot.ref.getDownloadURL().then(uploadedPUrl => {
            this.$store.commit("Loader", false);
            var col = this.collection;

            if (this.collection == "Drink") {
              var sDrink = this.selectedDrink;
              this.$store.commit("uploadImageForDrink", {
                selectedDrink: sDrink,
                imageUrl: uploadedPUrl
              });
              this.$store.commit("getImage", this.selectedDrink);
            } else {
              this.$store.commit("uploadImage", {
                collection: col,
                imageUrl: uploadedPUrl
              });
              this.$store.commit("getImage", this.collection);
            }

            this.imageUrl = "";
            this.imageData = "";
          });
        }
      );
    },

    onImageTap(image, docRef) {
      this.dialog = true;
      this.imageToDelete = image;
      this.docRef = docRef;
    },

    onCancel() {
      this.dialog = false;
    },

    onDelete() {
      firebase
        .storage()
        .refFromURL(this.imageToDelete)
        .delete();

      if (this.collection == "Drink") {
        firebase
          .firestore()
          .collection(this.selectedDrink)
          .doc(this.docRef)
          .delete();
        this.$store.commit("getImage", this.selectedDrink);
      } else {
        firebase
          .firestore()
          .collection(this.collection)
          .doc(this.docRef)
          .delete();
        this.$store.commit("getImage", this.collection);
      }

      this.dialog = false;
      alert("Delete successful.");
    }
  }
};
</script>

<style>
.changefont {
  font-size: 2rem;
  font-weight: bold;
  color: white;
}
.imageError {
  color: red;
}
</style>